import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Zzz = ({
  className = '~w-3/6 ~h-3/6',
  fill = COLOR.PRIMARY.LIGHT_900,
  fillDarkMode = COLOR.PRIMARY.DARK_500
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M21.6666 3.41567C21.1184 3.36124 20.5624 3.33337 19.9999 3.33337C10.7952 3.33337 3.33325 10.7953 3.33325 20C3.33325 29.2047 10.7952 36.6667 19.9999 36.6667C29.2046 36.6667 36.6666 29.2047 36.6666 20C36.6666 18.8585 36.5518 17.7437 36.3333 16.6667'
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.6667 18.3333H14.5119C13.7573 18.3333 13.0336 18.0335 12.5 17.5M23.3333 18.3333H25.4882C26.2427 18.3333 26.9665 18.0335 27.5 17.5'
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.0001 30C21.841 30 23.3334 28.5077 23.3334 26.6667C23.3334 24.8258 21.841 23.3334 20.0001 23.3334C18.1591 23.3334 16.6667 24.8258 16.6667 26.6667C16.6667 28.5077 18.1591 30 20.0001 30Z'
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.3333 3.33337H33.2456C34.2791 3.33337 34.7958 3.33337 34.9334 3.66686C35.0711 4.00036 34.7194 4.40042 34.0163 5.20054L29.9743 9.79954C29.2711 10.5997 28.9194 10.9997 29.0571 11.3332C29.1948 11.6667 29.7114 11.6667 30.7449 11.6667H34.9999'
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Zzz;
